import {  Box, Button, Heading, Image,  Select,  Text,  } from '@chakra-ui/react'
import Footer from '../Common/Footer'
import React, {  useState } from 'react'
import MarketingPageAccordation from '../Common/MarketingPageAccordation'
import MarketingPageComponent from '../Common/MarketingPageComponent'

function Marketing() {
    const [pre, setPre] = useState("23,000")
    const [sta, setSta] = useState("1,150")
    const [ess, setEss] = useState("770")
    const [fre, setFre] = useState("0")
    const [currency, setCurrency] = useState("inr")
    const [toggle, setToggle] = useState(false)
    const [symbol, setSymbol] = useState("₹")
    const premium={
        id:1,
        type:"Premium",
        des:"Advanced features for pros who need more customization.",
        month_des:"Monthly email sends: 15x plan’s contact limit.",
        btn:"About Premium"
    }
    const standard={
        id:2,
        type:"Standard",
        des:"Data-driven automation and optimization tools for businesses that want to grow faster.",
        month_des:"Monthly email sends: 12x plan’s contact limit.",
        btn:"About Standard"
    }
    const essentials={
        id:3,
        type:"Essentials",
        des:"Great for email-only senders who want around-the-clock support.",
        month_des:"Monthly email sends: 10x plan’s contact limit.",
        btn:"About Essentials"
    }
    const free={
        id:4,
        type:"Free",
        des:"All the multi-channel tools you need to build your business and grow your audience.",
        month_des:"Monthly email send limit is 10,000 sends (daily limit of 2,000)",
        btn:"About Free"
    }
    const faqs = [
        {
            que:"What payment methods do you offer?",
            ans:"We accept all major credit cards, PayPal, and (in select countries) direct debit. We also support transactions in a range of currencies."
        },
        {
            que:"How do I switch to a different plan?",
            ans:"You can switch to a new plan at any time by going to the Billing page in your account. Select the plan you’d like to switch to and immediately start using new features."
        },
        {
            que:"Can I buy credits instead?",
            ans:"Yes. If you send emails infrequently and prefer to pay as you go, you can buy email credits as an alternative to a monthly plan."
        },
        {
            que:"Do you have pricing for high-volume email senders?",
            ans:"We do indeed. If you have more than 200,000 contacts, we have a high-volume plan that can meet your needs."
        },
        {
            que:"What happens if I hit my contact or sending limit?",
            ans:"Mailchimp will automatically bill you for your overages. As long as you pay for your overages on time, we will not stop your campaigns or pause your account."
        },
    ]
    const priceData = [
        {
            id:1,
            price : 500,
            pre: '23,000',
            sta : '1,150',
            ess: '770',
            free:'0'
        },
        {
            id:2,
            price : 1500,
            pre: '23,000',
            sta : '3,850',
            ess: '1,500',
            free:'0'
        },
        {
            id:3,
            price : 2500,
            pre: '23,000',
            sta : '3,850',
            ess: '2,300',
            free:false
        },
        {
            id:4,
            price : 5000,
            pre: '23,000',
            sta : '5,800',
            ess: '3,850',
            free:false
        },
        {
            id:5,
            price : 10000,
            pre: '23,000',
            sta : '7,600',
            ess: '5,800',
            free:false
        },
        {
            id:6,
            price : 15000,
            pre: '27,000',
            sta : '12,200',
            ess: '9,900',
            free:false
        },
        {
            id:7,
            price : 20000,
            pre: '31,000',
            sta : '14,500',
            ess: '12,200',
            free:false
        },
        {
            id:8,
            price : 25000,
            pre: '34,500',
            sta : '17,000',
            ess: '14,500',
            free:false
        },
        {
            id:9,
            price : 30000,
            pre: '38,500',
            sta : '19,500',
            ess: '17,000',
            free:false
        },
        {
            id:10,
            price : 40000,
            pre: '42,500',
            sta : '21,000',
            ess: '19,500',
            free:false
        },
        {
            id:11,
            price : 50000,
            pre: '46,000',
            sta : '23,000',
            ess: '20,000',
            free:false
        },
        {
            id:12,
            price : 75000,
            pre: '50,000',
            sta : '31,000',
            ess: false,
            free:false
        },
        {
            id:13,
            price : 100000,
            pre: '54,000',
            sta : '38,500',
            ess: false,
            free:false
        },
        {
            id:14,
            price : 130000,
            pre: '61,500',
            sta : false,
            ess: false,
            free:false
        },
        {
            id:15,
            price : 150000,
            pre: '69,000',
            sta : false,
            ess: false,
            free:false
        },
        {
            id:16,
            price : 200000,
            pre: '84,500',
            sta : false,
            ess: false,
            free:false
        },
        {
            id:17,
            price : 250000,
            pre: false,
            sta : false,
            ess: false,
            free:false
        },
    ]
    const related_links =[
        {
          to:'/',
          title:'Landing Page Creator'
        },
        {
          to:'/',
          title:'Website Builder'
        },
        {
          to:'/',
          title:'Transactional Email'
        }
     ]
     const usdPriceData = [
        {
            id:1,
            price : 500,
            pre: '286',
            sta : '14',
            ess: '9',
            free:'0'
        },
        {
            id:2,
            price : 1500,
            pre: '286',
            sta : '47',
            ess: '18',
            free:'0'
        },
        {
            id:3,
            price : 2500,
            pre: '286',
            sta : '47',
            ess: '28',
            free:false
        },
        {
            id:4,
            price : 5000,
            pre: '286',
            sta : '72',
            ess: '47',
            free:false
        },
        {
            id:5,
            price : 10000,
            pre: '286',
            sta : '94',
            ess: '72',
            free:false
        },
        {
            id:6,
            price : 15000,
            pre: '335',
            sta : '151',
            ess: '123',
            free:false
        },
        {
            id:7,
            price : 20000,
            pre: '385',
            sta : '180',
            ess: '151',
            free:false
        },
        {
            id:8,
            price : 25000,
            pre: '429',
            sta : '211',
            ess: '180',
            free:false
        },
        {
            id:9,
            price : 30000,
            pre: '479',
            sta : '242',
            ess: '211',
            free:false
        },
        {
            id:10,
            price : 40000,
            pre: '528',
            sta : '261',
            ess: '242',
            free:false
        },
        {
            id:11,
            price : 50000,
            pre: '572',
            sta : '286',
            ess: '248',
            free:false
        },
        {
            id:12,
            price : 75000,
            pre: '622',
            sta : '385',
            ess: false,
            free:false
        },
        {
            id:13,
            price : 100000,
            pre: '671',
            sta : '479',
            ess: false,
            free:false
        },
        {
            id:14,
            price : 130000,
            pre: '765',
            sta : false,
            ess: false,
            free:false
        },
        {
            id:15,
            price : 150000,
            pre: '858',
            sta : false,
            ess: false,
            free:false
        },
        {
            id:16,
            price : 200000,
            pre: '1,051',
            sta : false,
            ess: false,
            free:false
        },
        {
            id:17,
            price : 250000,
            pre: false,
            sta : false,
            ess: false,
            free:false
        },
    ]
    function onChange(e){
        const {value} = e.target
        console.log(currency)

        for(let i=0; i<priceData.length; i++){
            if(+value===priceData[i].price){
                setPre(currency==='inr' ? priceData[i].pre : usdPriceData[i].pre)
                setSta(currency==='inr' ? priceData[i].sta : usdPriceData[i].sta)
                setEss(currency==='inr' ? priceData[i].ess : usdPriceData[i].ess)
                setFre(currency==='inr' ? priceData[i].free : usdPriceData[i].free)
            }
        }
        console.log("checking",typeof(value))
    }
    
    
    function onCurChange(){
        if(currency==='inr'){
           setCurrency('usd')
        }else{
            setCurrency('inr')
        }
        if(currency==='inr'){
            setSymbol('$')
        }else{
            setSymbol('₹')
        }
        onChange()
    }
    
  return (
    <>
        <Box>
            <Box  mt="3rem" display="flex" alignItems="center" justifyContent="right">
                <Box mr="25%" display="flex" alignItems="center">
                    <Box border="1px solid" p="0.5rem 2rem">
                        <Text  fontSize="large" >How many contacts do you have?</Text>
                    </Box>
                    <Box border="1px solid" p="5px 10px">
                    <Select variant="unstyled" onChange={onChange} fontSize="24">
                        <option value='500'>500</option>
                        <option value='1500'>1,500</option>
                        <option value='2500'>2,500</option>
                        <option value='5000'>5,000</option>
                        <option value='10000'>10,000</option>
                        <option value='15000'>15,000</option>
                        <option value='20000'>20,000</option>
                        <option value='25000'>25,000</option>
                        <option value='30000'>30,000</option>
                        <option value='40000'>40,000</option>
                        <option value='50000'>50,000</option>
                        <option value='75000'>75,000</option>
                        <option value='100000'>100,000</option>
                        <option value='130000'>130,000</option>
                        <option value='150000'>150,000</option>
                        <option value='200000'>200,000</option>
                        <option value='250000'>250,000+</option>
                    </Select>
                    </Box>
                </Box>
                <Box>
                    <Select onChange={onCurChange} color="teal" fontWeight="bold" borderColor="transparent">
                        <option  value='inr'>₹ INR</option>
                        <option  value='usd'>$ USD</option>
                    </Select>
                </Box>
            </Box>
            
            <Box mt="2rem" display="flex">
               <MarketingPageComponent data={premium} symbol={symbol}  currency={currency} cost={pre}/>
               <MarketingPageComponent data={standard} symbol={symbol} currency={currency} cost={sta} />
               <MarketingPageComponent data={essentials}  symbol={symbol} currency={currency} cost={ess}/>
               <MarketingPageComponent data={free} symbol={symbol}  currency={currency} cost={fre}/>
            </Box>
            <Button mt="8" variant="outline" colorScheme="teal">Compare Our Plan</Button>
            <Box  mt="4rem">
                <Box mb="8rem" display="flex" justifyContent="center"  >
                    <Box width="41%" borderRight="1px solid" textAlign="left" p="0rem 3rem 2rem 1rem">
                        <Heading size="xl" fontWeight="400" mb="2rem">Also included: Free tools for getting your business online</Heading>
                        <Text mb="2rem">All Marketing plans come with <Button variant="link" colorScheme="teal">Free website and commerce features,</Button> so you can build your dream online presence. But if you want more advanced tools for selling and scheduling, try combining your Marketing plan with a paid Websites & Commerce plan.</Text>
                        <Button variant="outline" p="1rem 3rem" colorScheme="teal">See Websites & Commerce Plans</Button>
                    </Box>
                    <Box width="40%" borderLeft="1px solid" textAlign="left" p="0rem 1rem 2rem 3rem">
                        <Heading size="xl" fontWeight="400" mb="2rem">Prefer to pay as you go?</Heading>
                        <Text>Instead of paying a monthly recurring charge, you can buy email credits as needed through our Pay As You Go plan. It's best for infrequent senders.</Text>
                        <Button mt="6rem" variant="outline" p="1rem 3rem" colorScheme="teal">Learn More</Button>
                    </Box>
                </Box>
                <Box display="flex" justifyContent="center"  >
                    <Box width="41%" borderRight="1px solid" textAlign="left" p="0rem 3rem 2rem 1rem">
                        <Heading size="xl" fontWeight="400" mb="2rem">Two-factor authentication discount</Heading>
                        <Text mb="2rem">At Mailchimp, we’re serious about security. We offer a 10% discount for 1 month when you add two-factor authentication to your Mailchimp account with an app like Google Authenticator or SMS two-factor authentication.</Text>
                        <Text mb="2rem">Restrictions apply. See our full <Button variant="link" colorScheme="teal">terms and conditions.</Button></Text>
                        <Button variant="outline" p="1rem 3rem" colorScheme="teal">Get Started</Button>
                    </Box>
                    <Box width="40%" borderLeft="1px solid" textAlign="left" p="0rem 1rem 2rem 3rem">
                        <Heading size="xl" fontWeight="400" mb="2rem">Rates for nonprofits and charities</Heading>
                        <Text mb="5rem">Mailchimp offers a 15% discount to nonprofits and charities. To request the discount, sign up for a free account, and contact our Billing team with your username and a link to your organization’s website.</Text>
                        <Button variant="outline" p="1rem 3rem" colorScheme="teal">Get Started</Button>
                    </Box>
                </Box>
            </Box>
            <Box width="70%" mt="8rem">
                <Heading display="flex" size="xl" fontWeight="400" mb={4}>FAQ'S</Heading>
                <MarketingPageAccordation data={faqs}/>
            </Box>
            <Box m="8rem 0rem">
                <Heading w="30%" m="auto" mb="3rem">You’ll be in good company</Heading>
                <Box w="80%" display="flex" justifyContent="space-evenly" alignItems="center" >
                    <Image src="https://eep.io/images/yzco4xsimv0y/6EIjMFs2ZyQWsmOOYc4cGe/19d62aa558c8f5d4c4bf222e7e36571b/EastFork.png?w=520&fm=webp&q=70" alt="" w="120px" height="22px"/>
                    <Image src="https://eep.io/images/yzco4xsimv0y/5Z9C7t0HDyyaWu60iWE00A/2e3d2eaa056d0d86c6712c88d239762f/chronicle-books-logo.jpg?w=520&fm=webp&q=70" alt="" w="120px" height="100px"/>
                    <Image src="https://eep.io/images/yzco4xsimv0y/vHWiUSlrS8sSQc0cCesGY/429d539471239d6ffcdb8be8767140cb/Fader-Logo-800px-144dpi.jpg?w=520&fm=webp&q=70" alt="" w="120px" height="40px"/>
                    <Image src="https://eep.io/images/yzco4xsimv0y/2fZXnWbDK8ugIaCW8Qus0i/1b8f1c4aa80dda874418e4bfa29b60e5/Sweat.png?w=520&fm=webp&q=70" alt="" w="120px" height="30px"/>
                </Box>
            </Box>
            <Footer related_links={related_links}/>
        </Box>
    </>
  )
}

export default Marketing